import React from "react";
import HeaderMini from "../../components/HeaderMini/HeaderMini";
import Navbar from "../../components/Navbar/Navbar";
import OurGoal from "../../components/OurGoal/OurGoal";
import WhyUsCard from "../../components/WhyUsCard/WhyUsCard";
import WhyUsCardImg1 from "../../assests/img/why-us-card-img-1.jpg";
import WhyUsCardImg2 from "../../assests/img/why-us-card-img-2.jpg";
import WhyUsCardImg3 from "../../assests/img/why-us-card-img-3.jpg";
import WhyUsCardImg5 from "../../assests/img/why-us-card-img-5.jpg";
import WhyUsCardImg6 from "../../assests/img/why-us-card-img-6.jpg";
import WhyUsCardImg7 from "../../assests/img/why-us-card-img-7.jpg";
import bgWhyUs from "../../assests/img/background.jpeg";
import OurServices from "../../components/OurServices/OurServices";
import FooterMini from "../../components/FooterMini/FooterMini";
import ContactUsIcon1 from "../../assests/icon/contact-us-icon-1.svg";
import ContactUsIcon2 from "../../assests/icon/contact-us-icon-2.svg";
import ContactUsIcon3 from "../../assests/icon/contact-us-icon-3.svg";
import ContactUsIcon4 from "../../assests/icon/contact-us-icon-4.svg";
import ContactUsIcon5 from "../../assests/icon/contact-us-icon-5.svg";
import OurAssociation from "../../components/OurAssociation/OurAssociation";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import { FaLocationDot } from "react-icons/fa6";
import ImageSlider from "../../components/Slider/Slider";

function Home() {
  const latitude = -34.564349;
  const longitude = 150.8599785;

  const handleMarkerClick = (latitude, longitude) => {
    const address = "237 Shellharbour Road, Barrack Heights, 2528";
    const googleMapsUrl = `https://www.google.com/maps?q=${encodeURIComponent(
      address
    )}`;
    window.open(googleMapsUrl, "_blank");
  };

  const WhyUsData = [
    {
      image: WhyUsCardImg1,
      heading: "Staff",
      desc: "Our Dentists, chair side & front office staff are always willing to listen to you, accommodate you and provide appointments & treatments as per your convenience. We will respond to your queries quickly.",
    },
    {
      image: WhyUsCardImg2,
      heading: (
        <div className="flex justify-between">
          Location & Parking{" "}
          <button
            onClick={() => handleMarkerClick(latitude, longitude)}
            className="px-[1rem] text-[1.3rem] text-[#CC0000]"
          >
            <FaLocationDot />
          </button>
        </div>
      ),
      desc: "We are located on 237 Shellharbour Road, opposite to Ampol Foodary, Barrack Heights. Parking is available on site, on the main road and adjacent streets. Disability parking and wheelchair access is available.",
    },
    {
      image: WhyUsCardImg3,
      heading: "Anxiety free environment",
      desc: "Our warm welcoming ambience makes you feel at home. We offer Nitrous Oxide Sedation to alleviate your anxiety. Oral sedation/ Day surgery options are available for who are really anxious.",
    },
    {
      image: WhyUsCardImg5,
      heading: "You are important to us",
      desc: "We keep in mind your situation and overall health condition while addressing your oral health problems. We keep in touch with your doctors and specialists to provide quality dental treatment.",
    },
    {
      image: WhyUsCardImg6,
      heading: "Emergency Appointments",
      desc: "We make appointments available as per your requirement. You don't have to put up with pain. Contact us immediately in case of emergency. Online booking option and emergency appointments are available.",
    },
    {
      image: WhyUsCardImg7,
      heading: "Latest technology",
      desc: "Use of latest technology makes your dental treatment experience better. We are equipped with onsite OPG, intraoral scanner & camera, washer disinfector & etc. Our Sterilisation room and lab is designed to standards.",
    },
  ];

  const handleBookNow = () => {
    window.open("https://shellharbourroaddentists.portal.dental", "_blank");
  };

  return (
    <div className="home overflow-x-hidden">
      <div className="bg-[white]">
        <div>
          <Navbar />
        </div>
      </div>

      {/* Home Landing Section - Responsive */}
      <div className="home-landing-section flex items-center px-4 md:px-6 lg:px-8">
        <div className="container mx-auto flex flex-col justify-end items-start">
          <div className="flex-wrap font-poppins font-[600] text-3xl md:text-4xl lg:text-[54px] text-[#1A76D1] mt-24">
            Brighten <span className="text-black font-[400]">Your Smile</span>
          </div>
          <div className="mt-3 text-sm md:text-base">
            Advanced cosmetic dental services to restore your confidence with a
            healthy and beautiful smile.
          </div>
          <div className="flex flex-col mb-15">
            <div className="flex-wrap font-poppins font-[600] text-3xl md:text-4xl lg:text-[54px] text-[#1A76D1] mt-8">
              Our Goal
            </div>
            <div className="flex-wrap text-sm md:text-base">
              You are important to us, we prioritize your health, and work
              alongside with your GP and specialists guaranteeing utmost care
              and quality treatment at an affordable price. Most importantly our
              goal is to ensure a smile on your face.
            </div>
            <div className="mt-10 mb-10">
              <button
                onClick={handleBookNow}
                className="p-2 px-6 md:px-8 bg-[#00D3BE] rounded-[6px] text-white  md:text-[20px] font-[400]"
              >
                Experience your dental journey with us
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="case-study-1">
        <div className="container">
          <OurGoal />
        </div>
      </div>
      {/* Why Us Section - Responsive */}
      <div className="case-study-2">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 flex flex-col justify-center items-start">
          <div className="font-[600] text-3xl md:text-4xl lg:text-[54px] text-[#1A76D1] font-poppins mt-10">
            Why Us
          </div>
          <div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-x-[23px] md:gap-y-[23px]">
              {WhyUsData.map((items, index) => (
                <WhyUsCard key={index} props={items} />
              ))}
              <div className="col-span-1 md:col-span-2 mb-8 relative group">
                <img
                  src={bgWhyUs}
                  alt=""
                  className="mt-4 h-[200px] md:h-[260px] w-full object-cover rounded-[6px] overflow-hidden"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="brains-behind-infominez-section">
        <div className="container">
          <OurServices />
        </div>
      </div>
      {/* Our Associations Section - Responsive */}
      <div className="payment-options-section">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="flex flex-col justify-center items-start">
            <div className="text-white text-3xl md:text-4xl lg:text-[54px] font-[600] mt-8">
              Our Associations
            </div>
            <div className="bg-white rounded-[30px] w-full flex flex-col justify-center h-auto md:h-[50vh] my-50 mt-[2rem]">
              <ImageSlider />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <OurAssociation />
      </div>

      {/* Contact Us Section - Responsive */}
      <div className="">
        <div className="text-center text-2xl md:text-[32px] mt-10">
          Reach <br />
          <span className="text-[#1A76D1] text-3xl md:text-[45px] font-[600] leading-[0.8rem]">
            Contact Us
          </span>
        </div>
        <div className="text-center px-4 md:px-8 text-[12px]  md:text-base">
          Shellharbour Road Dentists is located on Shellharbour Rd, Barrack
          Heights a few minutes away from Warilla Grove Shopping Centre,
          Blackbutt, Flinders, Shellharbour Village, Shell Cove, Shellharbour
          City Centre, Albion Park Rail, Albion Park, Primbee, Windang and Oak
          Flats.
        </div>

        <div className="contact-us-section relative  mt-12">
          <div style={{ height: "80vh", width: "100%" }}>
            <APIProvider apiKey={"AIzaSyCSxcC8KD4LqOHxk6baZjaUx9Xqlwgqh_U"}>
              <Map
                style={{ width: "100vw", height: "100%" }}
                className={`
                    h-[80vh]  // Default height for mobile
                    // Medium screens get more height
                    md:h-[90vh]
                    lg:h-[85vh]  // Large screens get full 80vh
                     // Extra large screens can have even more
                  `}
                defaultCenter={{
                  lat: -34.564317,
                  lng: 150.860551,
                  address: "237 Shellharbour Road, Barrack Heights, 2528",
                }}
                defaultZoom={17.5}
                disableDefaultUI={true}
              >
                <Marker
                  onClick={() => handleMarkerClick()}
                  position={{ lat: -34.564317, lng: 150.860551 }}
                />
              </Map>
            </APIProvider>
          </div>

          <div
            className="bg-[#1A76D1]     w-full           // Full width on mobile 
    md:w-[50%]       // Wider on tablet 
    lg:w-[35%]       // Narrow on desktop
    p-4 
    md:p-6 
    md:px-8 
    md:absolute 
    md:right-[2rem]  // Adjusted right positioning for tablet 
    lg:right-[5rem]  // Back to original desktop positioning
    md:top-[56%] 
md:translate-y-[-50%]"
          >
            {/* Contact Info Sections */}
            {[
              {
                icon: ContactUsIcon1,
                title: "Emergency Phone",
                details: ["(02) 4216 9919"],
              },
              {
                icon: ContactUsIcon2,
                title: "Address",
                details: ["237 Shellharbour Road,", "Barrack Heights, 2528"],
              },
              {
                icon: ContactUsIcon4,
                title: "Book By Phone",
                details: [
                  "(02) 4216 9919",
                  "Call us 8.30 AM - 5.30 PM (Mon - Fri)",
                  "8 AM - 12 PM Sat",
                ],
              },
              {
                icon: ContactUsIcon5,
                title: "Book Online",
                details: [
                  <a
                    href="https://shellharbourroaddentists.portal.dental/"
                    key="online-booking"
                  >
                    Click Here
                  </a>,
                ],
              },
              {
                icon: ContactUsIcon3,
                title: "Email Us",
                details: ["info@shellharbourroaddentists.com.au"],
              },
            ].map((section, index) => (
              <div
                key={index}
                className="flex justify-start items-start my-4 md:my-0"
              >
                <div className="my-2 w-8 md:w-auto">
                  <img src={section.icon} alt="" className="h-full w-full" />
                </div>
                <div className="flex flex-col justify-between items-start mx-3 text-white">
                  <div className="text-[14px] md:text-[20px] font-[300]">
                    {section.title}
                    {section.details.map((detail, detailIndex) => (
                      <div
                        key={detailIndex}
                        className="text-[12px] md:text-[12px] font-[700] mt-1"
                      >
                        {detail}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-[4rem]">
        <FooterMini />
      </div>
    </div>
  );
}

export default Home;
